import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '首页', path: '/' },
    { label: '恋爱', path: '/category/romance' },
    { label: '奇幻', path: '/category/fantasy' },
    { label: '动作', path: '/category/action' },
    { label: '悬疑', path: '/category/suspense' },
    { label: '关于我们', path: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-xl text-accent-500"></i>
            </span>
            <span className="text-lg font-heading font-bold text-foreground-900">
              韩漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line mr-1"></i>
              搜索
            </button>
            <Link
              to="/category/romance"
              className="inline-flex items-center px-5 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <span className="w-4 h-4 flex items-center justify-center ml-1">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </Link>
          </div>

          <button
            type="button"
            className="md:hidden p-2 text-foreground-700 hover:text-foreground-900 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </span>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 transition-colors duration-200"
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/category/romance"
              className="inline-flex items-center justify-center px-5 py-2 mt-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              onClick={() => setMobileOpen(false)}
            >
              开始阅读
              <span className="w-4 h-4 flex items-center justify-center ml-1">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}